// slices/nonBankAnnualLeaveApiSlice.js
import { apiSlice } from './apiSlice';

export const nonBankAnnualLeaveApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({

    // Preview calculation — does NOT write to DB
    previewNonBankAnnualLeave: builder.query({
      query: ({ startDate, endDate, userId }) => ({
        url: '/api/non-bank-annual-leave/calculate',
        params: {
          startDate,
          endDate,
          ...(userId && { userId }),
        },
      }),
      providesTags: ['NonBankAnnualLeave'],
    }),

    // Apply calculation — writes newOpeningBalance to user records, never touches bringForward
    applyNonBankAnnualLeave: builder.mutation({
      query: ({ startDate, endDate, userIds = [] }) => ({
        url: '/api/non-bank-annual-leave/apply',
        method: 'POST',
        body: { startDate, endDate, userIds },
      }),
      invalidatesTags: ['NonBankAnnualLeave', 'User'],
    }),

    // End of Year rollover — copies Opening Balance into Bring Forward and
    // resets Opening Balance to 0, for one staff member or (with no userIds)
    // every staff member in this calculator's staff categories.
    endOfYearNonBankAnnualLeave: builder.mutation({
      query: ({ userIds = [] } = {}) => ({
        url: '/api/non-bank-annual-leave/end-of-year',
        method: 'POST',
        body: { userIds },
      }),
      invalidatesTags: ['NonBankAnnualLeave', 'User'],
    }),

    // Get non-bank leave config singleton
    getNonBankLeaveConfig: builder.query({
      query: () => '/api/non-bank-annual-leave/config',
      providesTags: ['NonBankLeaveConfig'],
    }),

    // Update non-bank leave config
    updateNonBankLeaveConfig: builder.mutation({
      query: (data) => ({
        url: '/api/non-bank-annual-leave/config',
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['NonBankLeaveConfig'],
    }),
  }),
});

export const {
  usePreviewNonBankAnnualLeaveQuery,
  useLazyPreviewNonBankAnnualLeaveQuery,
  useApplyNonBankAnnualLeaveMutation,
  useEndOfYearNonBankAnnualLeaveMutation,
  useGetNonBankLeaveConfigQuery,
  useUpdateNonBankLeaveConfigMutation,
} = nonBankAnnualLeaveApiSlice;
